<template>
    <div class="index" :style="height">
        
        <el-container :style="height">
            <el-menu :default-active="menuIndex" 
            :collapse="isCollapse" 
            @select="selectMenu" 
            unique-opened="true" 
            class="el-menu-vertical-demo"
            background-color="#191a23"
            text-color="hsla(0,0%,100%,.7)"
            active-text-color="#ffffff"
            >   
                <!-- <el-menu-item index="0-101" name="车险人伤"> -->
                <div class="logotitle">
                    <!-- <img src="../../assets/images/logo.png" alt=""> -->
                    <span slot="title" style="margin-left:15px">蜜仆</span>
                </div>
                <!-- </el-menu-item> -->
                <!-- <el-menu-item index="1" name="控制台" path="console">
                    <i class="el-icon-monitor"></i>
                    <span slot="title">控制台</span>
                </el-menu-item> -->
                <el-menu-item index="1" name="控制台" path="console">
                    <i class="el-icon-monitor"></i>
                    <span slot="title">控制台</span>
                </el-menu-item>
                <!-- <el-menu-item index="100" name="统计图" path="home">
                    <i class="el-icon-monitor"></i>
                    <span slot="title">统计图</span>
                </el-menu-item> -->
                <!-- <el-submenu index="2">
                    <template slot="title">
                        <i class="el-icon-s-ticket"></i>
                        <span slot="title">代办任务</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="2-1" name="代办任务>代办任务" path="taskAgents">
                            代办任务
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="3">
                    <template slot="title">
                        <i class="el-icon-edit-outline"></i>
                        <span slot="title">内容审核</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="3-1" name="内容审核>注册审核" path="contentAudit">
                            注册审核
                        </el-menu-item>
                        <el-menu-item index="3-2" name="内容审核>动态审核" path="contentAudit">
                            动态审核
                        </el-menu-item>
                        <el-menu-item index="3-3" name="内容审核>图片审核" path="contentAudit">
                            图片审核
                        </el-menu-item>
                        <el-menu-item index="3-4" name="内容审核>语音审核" path="contentAudit">
                            语音审核
                        </el-menu-item>
                        <el-menu-item index="3-5" name="内容审核>融云机审" path="contentAudit">
                            融云机审
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu> -->
                <el-submenu index="4">
                    <template slot="title">
                        <i class="el-icon-s-check"></i>
                        <span slot="title">用户管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="4-1" name="用户管理>用户管理" path="userManage">
                            用户管理
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-5" name="用户管理>音频审核" path="audioManage">
                            音频审核
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-6" name="用户管理>视频审核" path="videoManage">
                            视频审核
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-7" name="用户管理>真人图片" path="realImgManage">
                            真人图片
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-4" name="用户管理>黑名单" path="userBlack">
                            黑名单
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-3" name="用户管理>用户审核" path="userAduit">
                            用户审核
                        </el-menu-item>
                    </el-menu-item-group>
                    <!-- <el-menu-item-group>
                        <el-menu-item index="4-2" name="用户管理>导入资料" path="tanguo">
                            导入资料
                        </el-menu-item>
                    </el-menu-item-group> -->
                    <!-- <el-menu-item-group>
                        <el-menu-item index="4-3" name="用户管理>用户审核" path="userAduit">
                            用户审核
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-5" name="用户管理>音频审核" path="audioManage">
                            音频审核
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-6" name="用户管理>视频审核" path="videoManage">
                            视频审核
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-7" name="用户管理>真人图片" path="realImgManage">
                            真人图片
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="4-4" name="用户管理>黑名单" path="userBlack">
                            黑名单
                        </el-menu-item>
                    </el-menu-item-group> -->
                </el-submenu>
                <el-submenu index="10">
                    <template slot="title">
                        <i class="el-icon-umbrella"></i>
                        <span slot="title">动态管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="10-1" name="动态管理>动态管理" path="dynamic">
                            动态管理
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="5">
                    <template slot="title">
                        <i class="el-icon-money"></i>
                        <span slot="title">支付管理</span>
                    </template>
                    <el-menu-item-group>
                        
                        <!-- <el-menu-item index="5-1" name="支付管理>支付管理" path="payData">
                            支付管理
                        </el-menu-item> -->
                        
                        <el-menu-item index="5-1" name="支付管理>微信支付管理" path="wxPayManage">
                            微信支付管理
                        </el-menu-item>
                        <el-menu-item index="5-2" name="支付管理>支付宝支付管理" path="zfbPayManage">
                            支付宝支付管理
                        </el-menu-item> 
                        <el-menu-item index="5-3" name="支付管理>苹果支付管理" path="iosPayManage">
                            苹果支付管理
                        </el-menu-item>
                       <el-menu-item index="5-4" name="支付管理>解锁记录" path="unlockList">
                            解锁记录
                        </el-menu-item>
                      
                    </el-menu-item-group>
                </el-submenu>
               <el-submenu index="8">
                    <template slot="title">
                        <i class="el-icon-document-checked"></i>
                        <span slot="title">聊天管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="8-1" name="聊天管理>聊天列表" path="chatList">
                            聊天列表
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="7">
                    <template slot="title">
                        <i class="el-icon-s-comment"></i>
                        <span slot="title">推广管理</span>
                    </template>
                    <!-- <el-menu-item-group>
                        <el-menu-item index="7-1" name="推广管理>代理管理" path="agency">
                            代理管理
                        </el-menu-item>
                    </el-menu-item-group>
                    <el-menu-item-group>
                        <el-menu-item index="7-2" name="推广管理>中介管理" path="intermediary">
                            中介管理
                        </el-menu-item>
                    </el-menu-item-group> -->
                    <el-menu-item-group>
                        <el-menu-item index="7-3" name="提现管理>邀请管理" path="invite">
                            邀请管理
                        </el-menu-item>
                    </el-menu-item-group>
                    <!-- <el-menu-item-group>
                        <el-menu-item index="7-4" name="提现管理>邀请奖励管理" path="inviteManage">
                            邀请奖励管理
                        </el-menu-item>
                    </el-menu-item-group> -->
                    
                </el-submenu>
                <el-submenu index="11">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span slot="title">提现管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="11-1" name="提现管理>提现管理" path="withdrawal">
                            提现管理
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="6">
                    <template slot="title">
                        <i class="el-icon-info"></i>
                        <span slot="title">信息管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="6-1" name="信息管理>匿名举报管理" path="reportManage">
                            匿名举报管理
                        </el-menu-item>
                        <!-- <el-menu-item index="6-2" name="信息管理>意见反馈管理" path="feedback">
                            意见反馈管理
                        </el-menu-item>
                       <el-menu-item index="6-3" name="信息管理>回复设置管理" path="messages">
                            回复设置管理
                        </el-menu-item>
                        <el-menu-item index="6-4" name="信息管理>屏蔽词汇管理" path="dynamicVocabulary">
                            屏蔽词汇管理
                        </el-menu-item>
                        <el-menu-item index="6-5" name="信息管理>违禁词管理" path="forbiddenWord">
                            违禁词管理
                        </el-menu-item> -->
                    </el-menu-item-group>
                </el-submenu>

                <el-submenu index="12">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span slot="title">代发管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="12-1" name="代发管理>人员管理" path="agentUser">
                            人员管理
                        </el-menu-item>
                        <el-menu-item index="12-2" name="代发管理>任务管理" path="agentTask">
                            任务管理
                        </el-menu-item>
                        <el-menu-item index="12-3" name="代发管理>任务审核" path="agentTaskClaim">
                            任务审核
                        </el-menu-item>
                        <el-menu-item index="12-4" name="代发管理>任务提现" path="agentWithdraw">
                            任务提现
                        </el-menu-item>
                        <el-menu-item index="12-5" name="代发管理>评论管理" path="agentComment">
                            评论管理
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                 <!-- 
               

                 -->
                
                <!-- <el-submenu index="8">
                    <template slot="title">
                        <i class="el-icon-document-checked"></i>
                        <span slot="title">上架模式管理</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="8-1" name="上架模式管理>上架模式管理" path="shelves">
                            上架模式管理
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu index="9">
                    <template slot="title">
                        <i class="el-icon-setting"></i>
                        <span slot="title">系统通知</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item index="9-1" name="系统通知>系统通知" path="systemInforms">
                            系统通知
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu> -->
                <!-- <el-submenu :index="item.sortId+1" v-for="(item,index) in menus" :key="index">
                    <template slot="title">
                        <i :class="item.icon"></i>
                        <span slot="title">{{item.name}}</span>
                    </template>
                    <el-menu-item-group>
                        <el-menu-item :index="(item.sortId+1)+'-'+mitem.sortId" :name="item.name+'>'+mitem.name" :path="mitem.path" v-for="(mitem,mindex) in item.children" :key="mindex">
                            {{mitem.name}}
                            <div class="badge">
                                <el-badge :value="menuNum.zbXrw" class="mark" type="warning" :max="99" v-if="mitem.path=='task1-1'"/>
                                <el-badge :value="menuNum.zbDpg" class="mark" type="warning" :max="99" v-if="mitem.path=='task1-2'"/>
                                <el-badge :value="menuNum.zbDcz" class="mark" type="warning" :max="99" v-if="mitem.path=='task1-3'"/>
                                <el-badge :value="menuNum.zbDsh" class="mark" type="warning" :max="99" v-if="mitem.path=='task1-4(3)'"/>
                                <el-badge :value="menuNum.zbRwth" class="mark" type="warning" :max="99" v-if="mitem.path=='task1-8'"/>
                                <el-badge :value="menuNum.zbZyDsh" class="mark" type="warning" :max="99" v-if="mitem.path=='muchWorkAudit'"/>
                            </div>
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu> -->
            </el-menu>
        
            <el-container class="container">
                <el-header>
                    <div class="header-top">
                        <div class="header">
                            <div class="l">
                                <img src="../../assets/images/icon05.png" alt="" srcset="" v-if="!isCollapse" @click="showMenu">
                                <img src="../../assets/images/icon05x.png" alt="" srcset="" v-else  @click="showMenu">

                                <i class="el-icon-refresh-left" style="margin-left:15px"></i>

                                <div class="breadcrumb">
                                    <el-breadcrumb separator="/" style="margin-left:30px;">
                                        <el-breadcrumb-item  v-for="(item,index) in nameList" :key="index">{{item}}</el-breadcrumb-item>
                                    </el-breadcrumb>
                                </div>
                            </div>
                            <div class="r">
                                <div class="autocomplete">
                                    <el-autocomplete
                                        class="inline-input"
                                        v-model="searchValue"
                                        :fetch-suggestions="querySearch"
                                        placeholder="搜索..."
                                        @select="handleSelect"
                                        @keyup.enter.native="search"
                                        size="small"
                                    >
                                        <template slot-scope="{ item }">
                                            <div class="name">{{ item.label }}</div>
                                        </template>
                                    </el-autocomplete>
                                </div>
                                <el-popover
                                    placement="bottom"
                                    title="操作手册"
                                    width="110"
                                    trigger="hover"
                                    >
                                    <div class="document-btns">
                                        <div>
                                            <el-button icon="el-icon-share" type="text" @click="operationManual(1)">总部后台</el-button>
                                        </div>
                                        <div>
                                            <el-button icon="el-icon-share" type="text" @click="operationManual(2)">机构后台</el-button>
                                        </div>
                                        <div>
                                            <el-button icon="el-icon-share" type="text" @click="operationManual(3)">调查员后台</el-button>
                                        </div>
                                    </div>
                                    
                                    <el-button slot="reference" type="text" icon="el-icon-document" size="" style="margin-right:20px;font-size: 18px;color:#000000"></el-button>
                                </el-popover>
                                <el-button type="text" icon="el-icon-aim" size="" style="font-size: 18px;color:#000000" @click="aim" v-if="isFullScreen"></el-button>
                                <el-button type="text" icon="el-icon-full-screen" size="" style="font-size: 18px;color:#000000" @click="fullScreen" v-else></el-button>
                                <el-button type="text" icon="el-icon-setting" style="margin-right:10px;margin-left:20px;font-size: 18px;color:#000000" @click="goUpdatePassword"></el-button>
                                <el-button type="text" icon="el-icon-switch-button" @click="quit" style="margin-right:20px;font-size: 18px;color:#000000"></el-button>
                                <img src="../../assets/images/user.png" alt="">
                                <span class="r-span"><span class="name">您好！管理者
                                    <!-- {{name}} -->
                                </span></span> 
                            </div>
                        </div>
                    </div>
                    
                    <div class="tabs">
                        <div class="tabs-l">
                            <el-tabs v-model="tabsValue" type="card" closable @tab-remove="removeTab" @tab-click="clickTab" size='small'>
                                <el-tab-pane
                                    v-for="(item, index) in tabs"
                                    :key="index"
                                    :label="item.title"
                                    :name="item.path"
                                >
                                    <span slot="label" v-if="index==0"><i class="el-icon-s-platform" style="margin-right:4px"></i>控制台</span>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                        <div class="tabs-r">
                            <i class="el-icon-menu"></i>
                            <div class="handle">
                                <div class="handle-item" @click="closeTabOther">
                                    <i class="el-icon-close"></i>
                                    关闭其他
                                </div>
                                <div class="handle-item" @click="closeTabLeft">
                                    <i class="el-icon-back"></i>
                                    关闭左侧
                                </div>
                                <div class="handle-item" @click="closeTabRight">
                                    <i class="el-icon-right"></i>
                                    关闭右侧
                                </div>
                                <div class="handle-item" @click="closeTabAll">
                                    <i class="el-icon-close"></i>
                                    关闭全部
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </el-header>
                
                <el-main>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import api from '../../api/main'
import App from '../../App.vue';
import store from '../../store';
export default {
  components: { App },
    name: 'index',
    data () {
        return {
            mipu_issh: localStorage.getItem('mipu_issh'),

            height:'100%',
            isCollapse:false,
            nameList:['控制台'],
            tabs:[{
                title: '控制台',
                path: 'console',
                index:0
            }],
            tabsValue:'console',
            menus:[],
            role:'',
            menuIndex:0,
            parentMenuIndex:0,
            isFullScreen:false,
            name:'管理员',
            menuNum:{
                jgDsh: 0,
                jgShth: 0,
                jgXrw: 0,
                jgdcz: 0,
                jgdpg: 0,
                ryShth: 0,
                ryXrw: 0,
                rydcz: 0,
                ryywc: 0,
                zbDcz: 0,
                zbDpg: 0,
                zbDsh: 0,
                zbRwth: 0,
                zbXrw: 0,
                zbZyDsh: 0,
            },
            searchValue:'',
        }
    },
    created(){
        

    },
    mounted(){
        // this.getUserMenu();
        this.getHeight();
        if(store.getters['global/s_tabs'].length>0){
            this.tabs = store.getters['global/s_tabs'];
        }
        if(store.getters['global/s_tabsValue']){
            this.tabsValue = store.getters['global/s_tabsValue'];
            for(let index in this.tabs){
                if(this.tabsValue == this.tabs[index].path){
                    this.menuIndex = this.tabs[index].index;
                    this.parentMenuIndex = this.menuIndex.split('-')[0];
                    this.nameList = this.tabs[index].nameList;
                }
            }
        }
        // this.$router.push({name:this.tabsValue})
    },
    methods:{
        
        operationManual(index){
            if(index==1){
                window.open('http://120.24.255.164:4999/web/#/5/23');
            }else if(index==2){
                window.open('http://120.24.255.164:4999/web/#/6/29');
            }else if(index==3){
                window.open('http://120.24.255.164:4999/web/#/7/34');
            }
        },

        

        // 获取菜单
        // async getUserMenu(){
        //     let res  = await api.queryResource();
        //     this.menus = res.data.data;
        // },






        querySearch(){},
        handleSelect(){},
        search(){},
        // 关闭其他
        closeTabOther(){
            for(let i = 1;i<this.tabs.length;i++){
                if(this.tabs[i].path == this.tabsValue){
                    this.tabs = [this.tabs[0],this.tabs[i]]
                }else{
                }
            }
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },    
        // 关闭左侧
        closeTabLeft(){
            for(let i = 1;i<this.tabs.length;){
                if(this.tabs[i].path == this.tabsValue){
                    store.dispatch('global/setTabs', this.tabs);
                    store.dispatch('global/setTabsValue', this.tabsValue);
                    return;
                }else{
                    this.tabs.splice(i,1);
                }
            }
        },
        // 关闭右侧
        closeTabRight(){
            let startIndex = 1;
            for(let i = 1;i<this.tabs.length;i++){
                if(this.tabs[i].path == this.tabsValue){
                    startIndex = i+1;
                    continue;
                }
            }
            for(startIndex;startIndex<this.tabs.length;){
                this.tabs.splice(startIndex,1);
            }
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 关闭所有
        closeTabAll(){
            this.tabs = [this.tabs[0]];
            this.tabsValue = this.tabs[0].path;
            this.parentMenuIndex = 0;
            this.nameList = ['控制台'];
            this.$router.push({name:this.tabsValue});
            this.menuIndex = this.tabs[0].index
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        //获取浏览器的当前的高度
        getHeight(){
            let _this = this;
            _this.height =  'height:'+document.body.clientHeight+'px';
            window.onresize = function(){
                _this.height =  'height:'+document.body.clientHeight+'px';
            }
        },
        // 选择左侧菜单
        selectMenu(index,path,route){
            if(route.$attrs.path=='allAnXinCase'||route.$attrs.path=='anxinCaseAdd'||route.$attrs.path=='indexZY'){
            }else{
            }
            this.$router.push({name:route.$attrs.path});

            this.nameList = route.$attrs.name.split('>');
            this.menuIndex = index;
            this.parentMenuIndex = this.menuIndex.split('-')[0];
            store.dispatch('global/setTabsValue', route.$attrs.path);
            this.tabsValue = route.$attrs.path;
            for(let i=0;i<this.tabs.length;i++){
                if(this.tabs[i].path == route.$attrs.path){
                    store.dispatch('global/setTabsValue', this.tabsValue);
                    return;
                }
            }
            this.tabs.push({
                title: this.nameList[0]+'-'+this.nameList[this.nameList.length-1],
                path: route.$attrs.path,
                index:index,
                nameList:this.nameList,
            });
            this.tabsValue = route.$attrs.path;
            store.dispatch('global/setTabs', this.tabs);
           
        },
        // 查询页面操作权限
        async queryPermissionMenuOperation(path){
            for(let i in this.menus){
                for(let j in this.menus[i].children){
                    if(this.menus[i].children[j].path == path){
                        let res = await api.queryPermissionMenuOperation(this.menus[i].children[j].id);
                        localStorage.setItem('btns',JSON.stringify(res.data.data))
                        this.$router.push({name:path});
                        return;
                    }
                }
            }
        },
        // 跳转到更新密码页面
        goUpdatePassword(){
            this.$router.push({name:'updatePassword'});
        },
        // 显示隐藏菜单栏
        showMenu(){
            this.isCollapse = !this.isCollapse
        },
        
        // 切换tab
        clickTab(e){
            this.$router.push({name:this.tabs[e.index].path});
            this.menuIndex = this.tabs[e.index].index?this.tabs[e.index].index:false;
            if(this.menuIndex){
                this.parentMenuIndex = this.menuIndex.split('-')[0];
                localStorage.setItem('taskStatus',this.menuIndex.split('-')[1]);
                this.nameList = this.tabs[e.index].nameList;
            }else{
                this.parentMenuIndex = 0;
                this.menuIndex = 0;
                this.nameList = ['控制台']
            }
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 关闭tab
        removeTab(targetName){
            if(this.tabsValue === targetName){
                this.tabs.forEach((tab,index) => {
                    if(tab.path === targetName) {
                        console.log(this.tabs[index-1]);
                        this.menuIndex = this.tabs[index-1].index ? this.tabs[index-1].index : 0;
                        if(this.menuIndex == 0){
                            this.parentMenuIndex = 0;
                        }
                        this.tabsValue = this.tabs[index-1].path;
                        this.$router.push({name:this.tabsValue});
                        this.nameList = this.tabs[index-1].nameList?this.tabs[index-1].nameList:['控制台'];
                        return;
                    }
                })
            }
            this.tabs = this.tabs.filter(tab => tab.path !== targetName);
            store.dispatch('global/setTabs', this.tabs);
            store.dispatch('global/setTabsValue', this.tabsValue);
        },
        // 退出登录
        quit(){
            this.$confirm('将退出登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$message({
                    type: 'success',
                    message: '退出成功!'
                });
                store.dispatch('global/setTabs', []);
                store.dispatch('global/setTabsValue', '');
                localStorage.removeItem('accessToken');
                this.$router.push({ name: 'login' });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        
        // 全屏
        fullScreen(){
            var docElm = document.documentElement;  
            //W3C   
            if (docElm.requestFullscreen) {  
                docElm.requestFullscreen();  
            }  
                //FireFox   
            else if (docElm.mozRequestFullScreen) {  
                docElm.mozRequestFullScreen();  
            }  
                //Chrome等   
            else if (docElm.webkitRequestFullScreen) {  
                docElm.webkitRequestFullScreen();  
            }  
                //IE11   
            else if (elem.msRequestFullscreen) {  
                elem.msRequestFullscreen();  
            }  
            this.isFullScreen = true;
        },
        aim(){
            if (document.exitFullscreen) {  
                document.exitFullscreen();  
            }  
            else if (document.mozCancelFullScreen) {  
                document.mozCancelFullScreen();  
            }  
            else if (document.webkitCancelFullScreen) {  
                document.webkitCancelFullScreen();  
            }  
            else if (document.msExitFullscreen) {  
                document.msExitFullscreen();  
            }  
            this.isFullScreen = false;

        },
        
        
    }
    
}
</script>

<style lang="scss" scoped>
   
    .index{
        background-color: #ffffff;
        min-height: 100%;
        .logotitle{
            height: 65px;
            width: 100%;
            font-size: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #409EFF;
            border-bottom: 1px solid #101117;
            // background-color: #409EFF;
            img{
                width: 30px;
                height: 30px;
            }
            span{
                overflow: hidden;
                width: 100px;
                white-space:nowrap;
            }
        }
        .document-btns{
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        /deep/.el-container{
            flex: 1;
        }
        /deep/.el-badge__content--warning{
            background: #f90;
            border-color:#f90;
        }
        /deep/.el-menu-item-group{
            .el-menu-item{
                background-color: #101117!important;
            }
        }
        /deep/.el-menu{
            overflow: hidden;

            .is-active{
                background: #2d8cf0!important;
                .el-submenu__title{
                    color: #ffffff!important;
                    i{
                        color: #ffffff!important;
                    }
                }
            }
        } 
        
        /deep/.el-menu-item{
            display: flex;
            align-items: center;
            i{
                color:hsla(0,0%,100%,.7);
                margin-right:10px;
            }
            .badge{
                height: 50px;
                margin-bottom: 16px;
                margin-left: 4px;
            }
        }
        /deep/.el-submenu__title{
            i{
                color:hsla(0,0%,100%,.7);
                margin-right:10px;
            }
        }
        /deep/.el-menu-item-group__title{
            padding:0;
        } 
        /deep/.el-header{
            height: 120px !important;
            padding: 0;
            background-color: #ffffff;
            
            .header-top{
                width: 100%;
                height: 60px;
                background-color: #ffffff;
                // position: relative;
                z-index: 10;
                box-shadow: 0 1px 4px rgba(0,21,41,.08);
            }
            .header{
                background-color: #FFFFFF;
                width: 100%;
                height: 60px;
                margin-bottom: 2px;
                // border-bottom: 1px solid #DEDEDE;
                display: flex;
                align-items: center;
                justify-content: space-between;
                

                .l{
                    height: 21px;
                    margin-left: 15px;
                    display: flex;
                    align-items: center;
                    img{
                        width: 15px;
                        height: 12px;
                        cursor: pointer;
                    }

                    .breadcrumb{
                        background-color: #FFFFFF;
                        height: 40px;
                        display: flex;
                        align-items: center;
                        margin-left: 10px;
                        .el-breadcrumb{
                            margin-left: 5px!important;
                            .el-breadcrumb__inner{
                                font-size: 14px;
                                // font-weight: bold;
                                color: #000000 !important;
                            }
                        }
                        
                    }
                }
                .r{
                    height:46px;
                    display: flex;
                    align-items: center;
                    .autocomplete{
                        margin-right: 25px;
                    }
                    .r-span{
                        line-height: 46px;
                        margin-right: 20px;
                        font-size: 14px;
                        .name{
                            color: #606266;
                            margin-right: 0;
                        }
                       
                    }
                    img{
                        width: 26px;
                        margin-right: 4px;
                        margin-top: 2px;
                    }
                    /deep/.el-button{
                        i{
                            font-size: 16px !important;
                        }
                    }
                }
                .popover{
                    width: 100px;
                    border:1px solid #ffffff;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
            }
            .tabs{
                // background-color: #FFFFFF;
                padding: 8px;
                box-shadow: 0 1px 4px rgba(0,21,41,.08);
                height: 36px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                z-index: 9;
                // border-bottom: 1px solid #DEDEDE;
                .el-tabs--card>.el-tabs__header{
                    border: 0;
                }
                .el-tabs--card>.el-tabs__header .el-tabs__nav{
                    border: 0;
                    background-color: #FFFFFF;
                }
                .el-tabs__header{
                    margin: 0;
                }
                .el-tabs--card>.el-tabs__header .el-tabs__item{
                    border: 1px solid #e4e7ed;
                    border-radius: 5px;
                    margin-right: 10px;
                    height: 36px;
                    line-height: 36px;
                    padding: 0 18px;
                }
                .el-tabs__nav .el-tabs__item:nth-child(1) .el-icon-close{
                    display: none;
                }
                .el-tabs{
                    padding-right: 30px;
                }
                .el-tabs__nav-next, .el-tabs__nav-prev{
                    line-height: 35px;
                }
                .tabs-l{
                    width: 100%;
                }
                .tabs-r{
                    height: 40px;
                    display: flex;
                    align-items: center;
                    font-size: 20px;
                    position:absolute;
                    right: 12px;
                    cursor: pointer;
                    .i{
                        font-size: 24px;
                    }
                }
                .handle{
                    // border: 1px solid #000000;
                    display: none;
                    width: 100px;
                    height: 100px;
                    position: absolute;
                    right: 2px;
                    top: 30px;
                    z-index: 9999;
                    background-color: #ffffff;
                    box-shadow: 0 2px 12px 0 rgba(163, 163, 163, 0.363);
                    padding: 6px 0;
                    transition: .3s;
                }

                .handle-item{
                    padding-left: 12px;
                    height: 25px;
                    line-height: 22px;
                    font-size: 13px;
                    color: #222222;
                    cursor: pointer;
                    transition: .3s;
                    i{
                        font-size: 14px;
                    }
                }
                .tabs-r:hover .handle{
                    display: block;
                }
                .handle-item:hover{
                    color: #409EFF;
                }
            }
        }
        /deep/.el-main{
            padding: 10px;
            padding-top: 0px;
        }
        /deep/.el-menu--collapse{
            width: 64px;
            .el-menu-item{
                display: flex;
                // justify-content: center;
            }
            .logotitle{
                span{
                    
                    display: none;
                }
            }
        } 
        /deep/.el-submenu__title{
            width: 250px;
        }
        .el-menu-vertical-demo:not(.el-menu--collapse) {
            width: 250px;
            min-height: 400px;
            box-shadow: 2px 0 6px 0 rgba(0,21,41,.3)
        }
    }
    
  
</style>
